import { ReactElement, useCallback } from 'react';
import { useAppNavigation } from 'contexts/navigation';
import { useProjectId } from 'store/project';

type DocumentationFileNavigationActionRenderProps = {
  canNavigate: boolean;
  navigateToDocumentationFile: () => void;
};

type DocumentationFileNavigationActionProps = {
  documentationId?: string;
  children: (
    props: DocumentationFileNavigationActionRenderProps
  ) => ReactElement | null;
};

export function DocumentationFileNavigationAction({
  documentationId,
  children,
}: DocumentationFileNavigationActionProps): ReactElement | null {
  const projectId = useProjectId();
  const { goToDocumentationFile } = useAppNavigation();

  const canNavigate = Boolean(projectId && documentationId);

  const navigateToDocumentationFile = useCallback((): void => {
    if (!projectId || !documentationId) {
      return;
    }

    goToDocumentationFile(projectId, documentationId, {
      replace: true,
    });
  }, [documentationId, goToDocumentationFile, projectId]);

  return children({ canNavigate, navigateToDocumentationFile });
}
